import { Building2, Clock, FileSignature, Receipt, Server, Settings, Users } from 'lucide-react';

export type NavSection = {
  label: string;
  items: { path: string; label: string; icon: typeof Users }[];
};

export const advisorClientSections: NavSection[] = [
  { label: '', items: [{ path: 'overview', label: 'Client Profile', icon: Building2 }] },
  {
    label: 'Run their automations',
    items: [
      { path: 'servers', label: 'Servers', icon: Server },
      { path: 'users', label: 'People', icon: Users },
    ],
  },
  {
    label: 'Money',
    items: [
      { path: 'offers', label: 'Offers & contracts', icon: FileSignature },
      { path: 'time', label: 'Time', icon: Clock },
      { path: 'billing', label: 'Billing', icon: Receipt },
    ],
  },
  { label: 'Settings', items: [{ path: 'info', label: 'Client Settings', icon: Settings }] },
];
